module.exports = __webpack_public_path__ + "img/aptamer_logo.841ca04e.png";